import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { TileScope } from '@api/models/dashboard/TileScope';
import { QcsTooltip } from '../../common/basic/QcsTooltip';
import { ConfigChipLabel } from './TileDialogStyles';

interface Props {
  value: TileScope;
  onChange: (scope: TileScope) => void;
  disabled?: boolean;
}

const RADIO_SX = { py: 0.25 } as const;
const LABEL_SX = { '& .MuiFormControlLabel-label': { fontSize: '0.85rem' } } as const;

export const TileTargetSelector: FC<Props> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  const content = (
    <div>
      <ConfigChipLabel style={{ marginBottom: '0.35rem', display: 'block' }}>
        {t('analytics.tile.targetLabel')}
      </ConfigChipLabel>
      <RadioGroup
        row
        value={value}
        onChange={(_, next) => onChange(next as TileScope)}
      >
        <FormControlLabel
          value="company"
          control={<Radio size="small" sx={RADIO_SX} />}
          label={t('analytics.tile.targetCompany')}
          disabled={disabled}
          sx={LABEL_SX}
        />
        <FormControlLabel
          value="global"
          control={<Radio size="small" sx={RADIO_SX} />}
          label={t('analytics.tile.targetGlobal')}
          disabled={disabled}
          sx={LABEL_SX}
        />
      </RadioGroup>
    </div>
  );

  if (disabled) {
    return (
      <QcsTooltip title={t('analytics.tile.scopeLockedTooltip')}>
        <div>{content}</div>
      </QcsTooltip>
    );
  }

  return content;
};
